import React from 'react';
import proptypes from 'prop-types';
import { CardTitle, Link, Typography } from '@one-thd/sui-atomic-components';
import { BuyAgain } from '@one-thd/sui-icons';

const { bool: boolType } = proptypes;

export const BuyAgainHeader = ({ showViewAllLink }) => {
  const buyAgainUrl = '/buyitagain';

  const publishViewAllOrdersClickEvent = () => {
    LIFE_CYCLE_EVENT_BUS.trigger('buy-it-again.viewAllLink');
    window.location.href = buyAgainUrl;
  };

  return (
    <CardTitle
      data-testid="buyAgain-header"
      header={(
        <div className="sui-flex sui-items-center sui-gap-3">
          <BuyAgain />
          <Typography variant="h3" weight="regular">Buy It Again</Typography>
        </div>
      )}
      disableActionSpacing
      action={showViewAllLink && (
        <div className="sui-flex">
          {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
          <Link
            onClick={publishViewAllOrdersClickEvent}
            data-testid="buyAgain-url"
          >
            View All
          </Link>
        </div>
      )}
    />
  );
};

BuyAgainHeader.propTypes = {
  showViewAllLink: boolType
};

BuyAgainHeader.defaultProps = {
  showViewAllLink: false
};